import React from 'react';

import { Spin as AntdSpin } from 'antd';

interface WaitingReferentielLoadingFieldProps {
  title: string;
}

export const WaitingReferentielLoadingField = ({
  title,
}: WaitingReferentielLoadingFieldProps): React.ReactElement => {
  return (
    <div className="WaitingForReferentiels">
      <label className="label" title={title}>
        {title}
      </label>
      <div className="input">
        <AntdSpin />
      </div>
    </div>
  );
};
